import { defineRouting } from 'next-intl/routing';

import { DEFAULT_LOCALE } from '@/lib/constants';
import { localeCodes } from '@/lib/i18n-locales';

export const routing = defineRouting({
	locales: localeCodes,
	defaultLocale: DEFAULT_LOCALE,
	localePrefix: 'as-needed',
	localeDetection: true,
});
